export const READ_LATER_COLLECTION_ID = 'readlater';
